import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class CourseService {

    AddCourse = async (course) => {
        return Auth.post('/courses/full', course)
    };

    GetById(courseID) {
        return Auth.get(`/courses/admin/${courseID}`)
    }
    UpdateByID(course, courseID){
        return Auth.put(`/courses/${courseID}/full`, course)
    }

    DeleteById(courseID) {
        return Auth.delete(`/courses/${courseID}`)
    }

    GetAllCourse = async (title = "", is_sold_out = false, type="") => {
        try {
            const queryParams = new URLSearchParams();
            if (title) queryParams.append('title', title);
            if (is_sold_out !== undefined) 
                queryParams.append('is_sold_out', is_sold_out);
            if (type) queryParams.append('type', title);
            
            const url = `/courses${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
            return Auth.get(url);
        } catch (error) {
            console.error('Error fetching courses:', error);
            throw error;
        }
    };

    GetAllCourseList(){
        return Auth.get('/courses');
    }

    GetAllCourseForSale = async (is_sold_out = false) => {
        try {
            const queryParams = new URLSearchParams();
            if (is_sold_out !== undefined) queryParams.append('is_sold_out', is_sold_out);
            
            const url = `/courses${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
            return Auth.get(url);
        } catch (error) {
            console.error('Error fetching courses:', error);
            throw error;
        }
    };

    GetforsaleById(courseID) {
        return Auth.get(`/courses/${courseID}`)
    }

    GetPurchaseCourse() {
        return Auth.get(`/courses/purchased`)
    }

    GetCourseFilesbyID(courseID){
        return Auth.get(`/courses/${courseID}/files`)
    }
}

export default CourseService

